import './index.scss';
import './assets/js/global';
